import _ from "lodash";
import moment from "moment";
import { configureEnvironment } from "../../config/env";

export function formatarCpf(cpf, retornoExcecao) {
  if (cpf) {
    cpf = cpf.replace(/[^\d]/g, "");
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }
  return retornoExcecao ? retornoExcecao : "";
}

export const calcularIdade = dataNascimento => {
  if (dataNascimento === null) return;
  dataNascimento = moment(dataNascimento).format('DD-MM-YYYY');
  let dataAtual = moment(new Date(), "DD-MM-YYYY");
  let dataNascimentoConvertida = moment(dataNascimento, "DD-MM-YYYY");
  return dataAtual.diff(dataNascimentoConvertida, "y");
};

export const formatarCampoTextoLetrasNumeros = str => {
  return str ? str.replace(/[^A-Za-z0-9À-ú´`~^' .]/gi, "") : "";
};

export function validarCpf(cpf) {
  cpf = cpf.replace(/[^\d]+/g, "");
  if (cpf === "") return false;

  const listaCpfsInvalidos = [
    "00000000000",
    "11111111111",
    "22222222222",
    "33333333333",
    "44444444444",
    "55555555555",
    "66666666666",
    "77777777777",
    "88888888888",
    "99999999999"
  ];

  if (cpf.length !== 11 || listaCpfsInvalidos.includes(cpf)) {
    return false;
  }

  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let rev = 11 - (soma % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }
  if (rev !== parseInt(cpf.charAt(9))) {
    return false;
  }
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  rev = 11 - (soma % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }
  if (rev !== parseInt(cpf.charAt(10))) return false;
  return true;
}

export const getOptionSolicitantesValue = option => {
  return option.id;
};

export const getOptionSolicitantesLabel = option => {
  return `${option.nome} - ${option.siglaConselho} ${option.numeroConselho}  / ${option.ufConselho}`;
};

export const getOptionPacienteValue = option => {
  return option.nome;
};

export const getOptionPacienteLabel = option => {
  return `${option.nome} - ${option.sexo} - ${option.cpf} - ${option.dataNascimento}`;
};

export const montarUrlHelpExames = (
  mnemonico,
  material,
  laboratorio
) => {
  const urlHelp = configureEnvironment().REACT_APP_URL_HELP_EXAMES;

  return urlHelp.replace("$REGIAO_PRODUTIVA$", laboratorio.regiaoProdutiva)
    .replace("$TIPO_NEGOCIO$", laboratorio.tipoNegocio)
    .replace("$EXAME$", `${material}||${mnemonico}`);
};

export const formatarUrlComSessionId = url => {
  return url + localStorage.getItem("idSecao");
};

export const transformarCamelCase = string => {
  return _.startCase(_.camelCase(string));
};

export const formatacaoMonetaria = valor => {
  return valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

export const converterStringToByteArray = string => {
  const byteCharacters = atob(string);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return byteArray;
};

export const obterCodigoPedidoRecoleta = codigoCompleto => {
  if (codigoCompleto) {
    var partes = codigoCompleto.split("||");
    if (partes.length === 3) return partes[2];
  }
  return null;
};

export const fazerDownloadDePdf = (bytes, nomeArquivo) => {
  const byteArray = converterStringToByteArray(bytes);
  const url = window.URL.createObjectURL(new Blob([byteArray]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", nomeArquivo);
  link.click();
  window.URL.revokeObjectURL(url);
  link.remove();
};

export const formatarData = data => {
  return data ? moment(data).format("DD/MM/YYYY") : null;
};

export const tratarStringVazia = string => (string ? string : "--");

export const removerCaracteresControle = value => {
  if (typeof value !== "string") return value;

  return value.replace(/[\u007F-\u009F]/g, '');
}
